import { dismissTopic } from './dismiss-topic/index.tsx';
import { fetchSuggestedTopics } from './fetch-suggested-topics/index.tsx';
import { setPagination } from './set-pagination/index.tsx';
import { filterTopics } from './filter-topics/index.tsx';
import { fetchAiDraftPreviewContent } from './fetch-ai-draft-preview-content/index.tsx';
import { triggerArticleGenerationForTopics } from './trigger-article-generation/index.tsx';

export const actions = {
	fetchSuggestedTopics,
	setPagination,
	dismissTopic,
	filterTopics,
	fetchAiDraftPreviewContent,
	triggerArticleGenerationForTopics,
} as const;

export type Actions = typeof actions;
